export class AnalysisState {
	public selectedCurrency?: string;
	public selectedBenchmark?: string;
	public iqStatusOrAreaOfFocus?: string;
}
